import { render, staticRenderFns } from "./follow-store.vue?vue&type=template&id=e2961022&scoped=true"
import script from "./follow-store.vue?vue&type=script&lang=js"
export * from "./follow-store.vue?vue&type=script&lang=js"
import style0 from "./follow-store.vue?vue&type=style&index=0&id=e2961022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2961022",
  null
  
)

export default component.exports